import styled from "@emotion/styled";

// Prevent layout shift when switching between 2 and 3 digit perPage
export const Count = styled.p`
  min-width: 156px;
  grid-area: count;
`;
